type DeepNonNullable<T> = T extends object
  ? { [K in keyof T]: DeepNonNullable<T[K]> }
  : T extends (infer U)[]
    ? DeepNonNullable<U>[]
    : Exclude<T, null | ''>

export default function removeEmptyValues<T extends object>(
  obj: T,
  options?: { removeNull?: boolean; removeEmptyString?: boolean },
): DeepNonNullable<T> {
  const result: any = Array.isArray(obj) ? [] : {}
  const { removeNull, removeEmptyString } = options || {
    removeNull: true,
    removeEmptyString: true,
  }
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key]

      if (removeNull && value === null) {
        continue
      }

      if (
        removeEmptyString &&
        typeof value === 'string' &&
        value.trim() === ''
      ) {
        continue
      }

      if (typeof value === 'object' && !(value instanceof Date)) {
        result[key] = removeEmptyValues(value as any)
      } else {
        result[key] = value
      }
    }
  }

  return result as DeepNonNullable<T>
}
